import commonMapping from "@/mapping/common";

export const mdns = {
  mdnsEnable: commonMapping.intToBoolean,
};

export default mdns;